import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Registration from "../views/Registration.vue";
import Login from "@/views/Login.vue";
import Scan from "@/views/Scan.vue";
import AuthSuccessful from "@/views/AuthSuccessful.vue";


const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/starthere",
  },
  {
    path:"/scan",
    name:"scan",
    component:Scan,
  },
  {
    path: "/starthere",
    name: "registration",
    component: Registration,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path:"/auth-successful",
    name:"authsuccessful",
    component:AuthSuccessful
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "forgot-password" */ "../views/ForgotPassword.vue"),
  },
  {
    path: "/change-password",
    name: "change-password",
    component: () => import("../views/ChangePassword.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
